import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import _ from 'lodash';

import { toggleGenerateFormModal } from '../../port-clearance-form-request/slices/portCallRequestSlice';

import Button from './Button';
import SendFormLayout from '../../captains-form/components/instructions/components/SendFormLayout';

import Logo from '../styles/images/nmap-logo.svg';

import '../styles/header.scss';

const Header = function (props) {
  const dispatch = useDispatch();
  let location = useLocation();
  const { formRef, mandatoryDocumentsFormRef } = props;

  const handleGenerateForm = async () => {
    const form = formRef.current;
    const errors = await form.validateForm();
    Object.keys(form.values).forEach((key) => {
      form.setFieldTouched(key, true);
    });

    const mandatoryDocumentsForm = mandatoryDocumentsFormRef.current;
    const mandatoryDocumentsFormErrors =
      await mandatoryDocumentsForm.validateForm();
    Object.keys(mandatoryDocumentsForm.values).forEach((key) => {
      mandatoryDocumentsForm.setFieldTouched(key, true);
    });

    if (_.isEmpty(errors) && _.isEmpty(mandatoryDocumentsFormErrors)) {
      form.submitForm();
      dispatch(toggleGenerateFormModal());
    }
  };

  const renderButton = () => {
    if (location.pathname.includes('/welcome')) return null;
    if (location.pathname.includes('/summary')) {
      return <SendFormLayout />;
    } else if (location.pathname.includes('/port-clearance-form-request')) {
      return (
        <Button className="generate-form-btn" onClick={handleGenerateForm}>
          Generate Form
        </Button>
      );
    }
    return null;
  };

  return (
    <header className="header">
      <div className="ncap-logo">
        <img src={Logo} alt="ncap-logo" />
      </div>
      <div className="header__buttons">{renderButton()}</div>
    </header>
  );
};

export default Header;
